import { useMemo } from 'react';
import { renderMarkdown } from '../lib/markdown.js';

/** Markdown, read-only: a task's detail when it is not being edited, and every
 * entry on its timeline. Writing it is MarkdownEditor's job. */
export function Markdown({ source }: { source: string }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return <div className="markdown text-sm" dangerouslySetInnerHTML={{ __html: html }} />;
}
